import React, {ChangeEvent, Dispatch} from 'react';
import {ReactComponent as SearchIcon} from '../../../../../../../assets/main/test/search.svg';
import {ReactComponent as PlusIcon} from '../../../../../../../assets/main/groups/main-table/period-calendar/plus.svg';
import {NavLink} from "react-router-dom";

interface IMyTestSearchProps {
    searchQuery: string;
    setSearchQuery: Dispatch<React.SetStateAction<string>>;
    onSearchInputChange: (value: string) => void;
}

export const TeacherTestSearch = (
    {
        searchQuery,
        setSearchQuery,
        onSearchInputChange,
    }: IMyTestSearchProps) => {
    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchQuery(value); // Обновляем локальное состояние
        onSearchInputChange(value); // Вызываем функцию обработчика
    };

    return (
        <div className="data-tbl-controls no-border">
            <form className="search-form">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Поиск"
                    value={searchQuery}
                    onChange={handleInputChange}
                />
                <button type="button" className="search-btn">
                    <SearchIcon/>
                </button>
            </form>

            <NavLink to="/test/create-test" className="btn small has-icon">
                 <span className="icon">
                    <PlusIcon />
                 </span>
                <span>Создать тест</span>
            </NavLink>
        </div>
    );
};
